import { motion, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";

function Counter({ to, suffix = "", duration = 1.4 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - start) / (duration * 1000));
      setVal(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, to, duration]);
  return (
    <span ref={ref}>
      {val.toLocaleString()}
      {suffix}
    </span>
  );
}

const STATS = [
  { v: 11, s: "+", label: "Industries served" },
  { v: 40, s: "h", label: "Avg. weekly hours saved" },
  { v: 100, s: "%", label: "Canadian operated" },
  { v: 6, s: "-step", label: "Onboarding process" },
];

export default function About() {
  return (
    <section id="about" className="relative py-28 lg:py-36 overflow-hidden" data-testid="about-section">
      <div className="absolute inset-0 grid-bg opacity-50 pointer-events-none" />
      <div className="container-apex relative">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <div className="overline">About Admin Apex</div>
            <h2 className="heading-display text-4xl sm:text-5xl lg:text-6xl mt-5 text-balance">
              We work as an <span className="text-[#16A34A]">extension</span> of your business — not a vendor on a contract.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-muted-foreground text-lg leading-relaxed">
              Every business deserves professional administrative support without the expense of hiring a full-time office team. We manage your day-to-day operations with professionalism, confidentiality, and efficiency — so you save time, reduce overhead, and finally have hours back to grow.
            </p>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-border rounded-2xl overflow-hidden border border-border">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08 }}
              className="bg-card p-8"
              data-testid={`stat-${i}`}
            >
              <div className="font-display font-black text-4xl lg:text-5xl tracking-tighter text-[#0B2545] dark:text-white">
                <Counter to={s.v} suffix={s.s} />
              </div>
              <div className="mt-2 text-sm text-muted-foreground font-medium">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
